<button
	data-test-id="app-button"
	[type]="type"
	class="app-button"
	[class.isPrimary]="isPrimary"
	[class.isWhite]="isWhite"
	[class.isWhiteBorder]="isWhiteBorder"
	[class.isSecondary]="isSecondary"
	[class.isGreen]="isGreen"
	[class.isSmall]="isSmall"
	[class.isInfo]="isInfo"
	[class.isRed]="isRed"
	[disabled]="disabled"
	(click)="clickHandler.emit($event)"
>
	<ng-content></ng-content>
</button>
